import { useAuthStore } from '@/store/authStore'
import { hasPermission } from '@/lib/permissions'
import { CapwayJobsSection } from '@/components/system/CapwayJobsSection'
import { PostnordJobsSection } from '@/components/system/PostnordJobsSection'

export function SystemPage(): React.ReactElement {
  const user = useAuthStore((state) => state.user)

  const canRunShipmentJobs = hasPermission(user, 'shipments.read', 'shipments.run')

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-serif text-primary">System</h1>

      <CapwayJobsSection />
      {canRunShipmentJobs && <PostnordJobsSection />}
    </div>
  )
}
